<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Quotation') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap justify-content-end>
              <v-flex xs5 pa-2>
                <v-autocomplete
                  id="quotation-focus-me"
                  v-model="form.customer_id_fk"
                  :label="`${$t('Customer')}`"
                  hide-details
                  :items="fullCustomersList"
                  box
                  data-vv-name="Customer"
                  background-color="white"
                  :error="errors.has('Customer')"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['customers_store'])">
                <v-tooltip top>
                  <v-btn label @click="$emit('add-customer')" slot="activator" icon fab small color="green">
                    <v-icon color="white" size="25">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new customer') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6 class="pa-2">
                <v-menu v-model="quotationDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="form.quotation_date"
                    :label="`${$t('Quotation Date')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="quotation_date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('quotation_date')"
                    v-validate="'required|date_format:yyyy-MM-dd'"
                  />
                  <v-date-picker @change="quotationDateMenu = false" v-model="form.quotation_date" />
                </v-menu>
              </v-flex>

              <v-flex xs12 style="margin-top: 20px">
                <v-layout row wrap class="form-table-header">
                  <v-flex class="form-table-content">
                    <v-layout row>
                      <v-flex xs1 pa-2>#</v-flex>
                      <v-flex xs9 pa-2>{{ $t('Product') }}</v-flex>
                      <v-flex xs2 v-if="hasPermissions(['products_store'])" style="padding-top: 3px">
                        <v-tooltip top>
                          <v-btn label @click="$emit('add-product')" slot="activator" icon small color="green">
                            <v-icon color="white">add</v-icon>
                          </v-btn>
                          <span>{{ $t('Add new product') }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs7 class="form-table-content" :class="{ xs8: hasCollection }">
                    <v-layout row>
                      <v-flex pa-2 v-if="hasDetail">{{ $t('Detail') }}</v-flex>
                      <v-flex pa-2 v-if="hasCollection">{{ $t('Collections') }}</v-flex>
                      <v-flex pa-2>{{ $t('Quantity') }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Price')} (${systemCurrency})` }}</v-flex>
                      <v-flex pa-2>{{ `${$t('Total')} (${systemCurrency})` }}</v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 style="padding-top: 3px" class="form-table-content">
                    <v-tooltip top>
                      <v-btn label @click="addRow()" small slot="activator" icon color="green">
                        <v-icon color="white">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>

                <template v-if="rowNumbers > 0">
                  <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                    <v-flex>
                      <v-layout row>
                        <v-flex xs1 pa-1 style="text-align: center; margin-top: 20px; font-size: 16px">{{
                          index + 1
                        }}</v-flex>
                        <v-flex xs11 pa-1>
                          <v-autocomplete
                            v-model="product_id_fk[index]"
                            :label="`${$t('Product')} *`"
                            :items="fullProductsList"
                            hide-details
                            box
                            :data-vv-name="'Product' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Product' + (index + 1))"
                            v-validate="'required'"
                            @input="getProductPrice(index, product_id_fk[index]), findCollections(index)"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs7 :class="{ xs8: hasCollection }">
                      <v-layout row>
                        <v-flex pa-1 v-if="hasDetail">
                          <v-text-field
                            v-model.number="sale_detail[index]"
                            :label="`${$t('Detail')} *`"
                            hide-details
                            box
                            :data-vv-name="'Detail' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Detail' + (index + 1))"
                          />
                        </v-flex>

                        <v-flex pa-1 v-if="hasCollection">
                          <v-autocomplete
                            v-model="collection_id_fk[index]"
                            :label="$t('Collections')"
                            :items="collections[index]"
                            item-text="collection_name"
                            item-value="collection_id"
                            hide-details
                            box
                            :disabled="collections[index] && collections[index].length === 0"
                            :data-vv-name="'Collections' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Collections' + (index + 1))"
                            @input="collectionPrice(index)"
                          />
                        </v-flex>

                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="quotation_quantity[index]"
                            :label="`${$t('Quantity')} *`"
                            hide-details
                            box
                            :data-vv-name="'Quantity' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Quantity' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            @input="calculateTotal(index)"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="quotation_price[index]"
                            :label="`${$t('Price')} (${systemCurrency}) *`"
                            hide-details
                            box
                            :data-vv-name="'Price' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Price' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            @input="calculateTotal(index)"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                        <v-flex pa-1>
                          <v-text-field
                            v-model.number="total[index]"
                            :label="`${$t('Total')} (${systemCurrency})*`"
                            hide-details
                            box
                            readonly
                            :data-vv-name="'Total' + (index + 1)"
                            background-color="white"
                            :error="errors.has('Total' + (index + 1))"
                            v-validate="'required|decimal:3'"
                            data-vv-delay="1000"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex
                      xs1
                      :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                      style="text-align: center"
                    >
                      <v-tooltip top>
                        <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                          <v-icon>delete</v-icon>
                        </v-btn>
                        <span>{{ $t('Remove this row') }}</span>
                      </v-tooltip>
                      <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                        <v-btn label @click="addRow()" small flat slot="activator" icon>
                          <v-icon size="28" color="green">add_circle</v-icon>
                        </v-btn>
                        <span>{{ $t('Add new row') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>

              <v-flex xs4 pa-2 pt-4 offset-xs8>
                <v-text-field
                  v-model="form.total_amount"
                  :label="`${$t('Total Amount')} (${systemCurrency}) *`"
                  hide-details
                  box
                  readonly
                  name="total_amount"
                  background-color="white"
                  :error="errors.has('total_amount')"
                  v-validate="'required|decimal:3'"
                  data-vv-delay="1000"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        quotation_date: '',
        total_amount: 0,
        customer_id_fk: 1
      },
      quotationDateMenu: false,
      product_id_fk: [],
      collection_id_fk: [],
      sale_detail: [],
      quotation_quantity: [],
      quotation_price: [],
      total: [],
      collections: [],
      rowNumbers: 1,
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      fullProductsList: 'products/getFullProductsList',
      fullCustomersList: 'customers/getSaleCustomersList',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    },
    hasDetail() {
      return this.settings.sale_detail === 'Active'
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addQuotation: 'quotations/addQuotation'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.product_id_fk = []
      this.collection_id_fk = []
      this.sale_detail = []
      this.quotation_quantity = []
      this.quotation_price = []
      this.total = [0]
      this.rowNumbers = 1
      this.form.quotation_date = this.$moment()
        .format()
        .substr(0, 10)
      this.form.total_amount = 0
      this.form.customer_id_fk = 1

      this.$nextTick(() => {
        this.$validator.resume()
        this.$validator.reset()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('quotation-focus-me').focus()
      })
    },

    findCollections(index) {
      const filteredProduct = this.fullProductsList.filter(item => item.value === this.product_id_fk[index])[0]
      this.collections[index] = filteredProduct.collections
    },

    findCollection(index) {
      return this.collections[index].filter(item => item.collection_id === this.collection_id_fk[index])[0]
    },

    collectionQuantity(index) {
      return this.findCollection(index).collection_quantity
    },

    collectionPrice(index) {
      if (this.collection_id_fk[index] === undefined) {
        let k = this.fullProductsList.findIndex(item => item.value === this.product_id_fk[index])
        this.quotation_price[index] = Number(this.fullProductsList[k].sale_price)
        return
      }
      this.quotation_price[index] = this.findCollection(index).collection_price
    },

    getProductPrice(index, product) {
      let k = this.fullProductsList.findIndex(item => item.value === product)
      let salePrice = this.fullProductsList[k].sale_price
      this.quotation_price[index] = Number(salePrice)
    },

    addRow() {
      this.total[this.rowNumbers] = 0
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.product_id_fk.splice(index, 1)
      this.collection_id_fk.splice(index, 1)
      this.sale_detail.splice(index, 1)
      this.quotation_quantity.splice(index, 1)
      this.quotation_price.splice(index, 1)
      this.total.splice(index, 1)
      this.calculateTotalAmount()
    },

    calculateTotal(index) {
      const quantity = this.quotation_quantity[index] || 0
      const price = this.quotation_price[index] || 0
      this.total[index] = Number((quantity * price).toFixed(2))
      this.calculateTotalAmount()
    },

    calculateTotalAmount() {
      this.form.total_amount = this.total.reduce((a, b) => a + b, 0)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true

          let formData = new FormData(event.target)
          formData.append('customer_id_fk', this.form.customer_id_fk)

          this.product_id_fk.forEach((p, index) => {
            formData.append('product_id_fk[' + [index] + ']', p)
            formData.append('detail[' + [index] + ']', this.sale_detail[index] || '')
            formData.append('collection_id_fk[' + index + ']', this.collection_id_fk[index] || '')
            if (this.collection_id_fk[index]) {
              formData.append('sale_collection_quantity[' + index + ']', this.quotation_quantity[index])
              formData.append('sale_collection_price[' + index + ']', this.quotation_price[index])
              formData.append(
                'sale_quantity[' + index + ']',
                (this.quotation_quantity[index] * this.collectionQuantity(index)).toFixed(2)
              )
              formData.append(
                'sale_price[' + index + ']',
                (this.quotation_price[index] / this.collectionQuantity(index)).toFixed(2)
              )
            } else {
              formData.append('sale_collection_quantity[' + index + ']', '')
              formData.append('sale_collection_price[' + index + ']', '')
              formData.append('sale_quantity[' + index + ']', this.quotation_quantity[index])
              formData.append('sale_price[' + index + ']', this.quotation_price[index])
            }
            formData.append('total[' + index + ']', this.total[index])
          })

          this.addQuotation(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
